import { Box, Button } from '@mui/material';
import useSimpleMenu from 'hooks/useSimpleMenu';
import DatePicker from 'components/DatePicker';
import {
  countStatisticsSearchRangeArray,
  TEAM_CREATION_RANGE_OPTIONS_ARRAY,
  TEAM_CREATION_RANGE_OPTIONS_HASH,
  TEAM_CREATION_RANGE_OPTIONS,
  COUNT_STATISTICS_SEARCH_RANGE,
  countStatisticsSearchRangeHash,
} from 'StatisticsModule/constants';
import { ValueOf } from 'type-fest';
import { Item } from 'types';

export type DashboardFiltersProps = {
  isLoading: boolean;
  teamCreationDateOption: ValueOf<typeof TEAM_CREATION_RANGE_OPTIONS>;
  selectedSearchDateRange: ValueOf<typeof COUNT_STATISTICS_SEARCH_RANGE>;
  tempCustomStart?: string;
  tempCustomEnd?: string;
  onSelectSearchRangeDate: (args: { item: Item }) => void;
  onSelectTeamCreationDate: (args: { option: ValueOf<typeof TEAM_CREATION_RANGE_OPTIONS> }) => void;
  onSelectCustomSearchRange: (args: {
    name: 'tempCustomStart' | 'tempCustomEnd';
    value: string;
  }) => void;
  triggerCountStatisticsFilter: (args: {
    teamIds?: number[];
    teamTags?: string[];
    teamCreationDateOption?: ValueOf<typeof TEAM_CREATION_RANGE_OPTIONS>;
    customOnly?: boolean;
  }) => void;
  shouldUseTeamCreationBounds?: boolean;
};

const DashboardFilters = ({
  isLoading,
  teamCreationDateOption,
  selectedSearchDateRange,
  onSelectSearchRangeDate,
  onSelectTeamCreationDate,
  onSelectCustomSearchRange,
  tempCustomStart,
  tempCustomEnd,
  triggerCountStatisticsFilter,
  shouldUseTeamCreationBounds = true,
}: DashboardFiltersProps) => {
  const { label } = countStatisticsSearchRangeHash[selectedSearchDateRange];
  const { label: teamCreationDateOptionLabel } =
    TEAM_CREATION_RANGE_OPTIONS_HASH[teamCreationDateOption];

  const { renderSimpleMenu: renderSearchDateRangeSelector } = useSimpleMenu({
    renderAnchorEl: () => {
      return (
        <Button disabled={isLoading} color="primary">
          {label}
        </Button>
      );
    },
  });

  const { renderSimpleMenu: renderTeamCreationDateFilter } = useSimpleMenu({
    renderAnchorEl: () => {
      return (
        <Button disabled={isLoading} color="primary">
          {teamCreationDateOptionLabel}
        </Button>
      );
    },
  });

  const isCustomRange = selectedSearchDateRange === COUNT_STATISTICS_SEARCH_RANGE.CUSTOM;

  return (
    <Box
      component="div"
      display="flex"
      gap={'2rem'}
      paddingLeft="16px"
      paddingBottom={'1rem'}
      alignItems={'center'}
    >
      <Box display="flex" flexDirection="column" alignItems={'flex-start'}>
        <Box component="h4" paddingBottom={'0px'}>
          Data From
        </Box>{' '}
        {renderSearchDateRangeSelector({
          disabled: isLoading,
          items: [
            ...countStatisticsSearchRangeArray.map((searchRangeItem) => ({
              ...searchRangeItem,
              onClick: () => onSelectSearchRangeDate({ item: searchRangeItem }),
            })),
          ],
        })}
        {isCustomRange ? (
          <>
            <Box display={'flex'} gap="5px" paddingTop="10px">
              <DatePicker
                label="Start Date"
                value={tempCustomStart}
                onChange={(newDate) =>
                  onSelectCustomSearchRange({ name: 'tempCustomStart', value: newDate ?? '' })
                }
              />
              <DatePicker
                label="End Date"
                value={tempCustomEnd}
                onChange={(newDate) =>
                  onSelectCustomSearchRange({ name: 'tempCustomEnd', value: newDate ?? '' })
                }
              />
            </Box>
            <Box paddingTop="10px">
              <Button
                onClick={() => {
                  triggerCountStatisticsFilter({ customOnly: true });
                }}
                color="primary"
                variant="outlined"
                disabled={!tempCustomStart || !tempCustomEnd || isLoading}
              >
                Search custom
              </Button>
            </Box>
          </>
        ) : (
          <></>
        )}
      </Box>{' '}
      {shouldUseTeamCreationBounds && (
        <Box>
          <Box component="h4" paddingBottom={'0px'}>
            Team Creation Date
          </Box>{' '}
          {renderTeamCreationDateFilter({
            disabled: isLoading,
            items: TEAM_CREATION_RANGE_OPTIONS_ARRAY.map((teamCreationRange) => ({
              ...teamCreationRange,
              onClick: () => onSelectTeamCreationDate({ option: teamCreationRange.value }),
            })),
          })}
          {/* {shouldUseTeamCreationBounds && (
            <Card>
              <Box display={"flex"}>
                <Box padding={6}>
                  {" "}
                  <TextField
                    label="Upper Bound"
                    type="date"
                    className="text-field"
                    value={teamCreationDateUpperBound}
                    onChange={(e) =>
                      onSelectTeamCreationDate(
                        e,
                        TEAM_CREATION_DATE_BOUND_KEYS.UPPER
                      )
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box padding={6}>
                  <TextField
                    label="Lower Bound"
                    type="date"
                    className="text-field"
                    value={teamCreationDateLowerBound}
                    onChange={(e) =>
                      onSelectTeamCreationDate(
                        e,
                        TEAM_CREATION_DATE_BOUND_KEYS.LOWER
                      )
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />  
                </Box>
              </Box>
            </Card>
          )} */}
        </Box>
      )}
    </Box>
  );
};

export default DashboardFilters;
